import React from 'react';
import { Box } from '@mui/material';
import { useSelector } from 'react-redux';
import type { RootState } from '../../utils/redux_store/store';
import { AdminDashboard } from './AdminDashboard';
import { ParticipantDashboard } from './ParticipantDashboard';

export const Home = () => {
  const currentView = useSelector((state: RootState) => state.view.currentView);

  const renderLandingPage = () => {
    if (currentView === 'Participant') {
      return <ParticipantDashboard />;
    }
    if (currentView === 'Admin') {
      return <AdminDashboard />;
    }
    return null;
  };

  return (
    <Box sx={{ width: '100%', minWidth: 0, bgcolor: 'background.default' }}>
      {renderLandingPage()}
    </Box>
  );
};
